import { render, staticRenderFns } from "./list_receipt.vue?vue&type=template&id=22a8df03&scoped=true"
import script from "./list_receipt.vue?vue&type=script&lang=js"
export * from "./list_receipt.vue?vue&type=script&lang=js"
import style0 from "./list_receipt.vue?vue&type=style&index=0&id=22a8df03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8df03",
  null
  
)

export default component.exports